/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateExternalFolder
 */
export interface CreateExternalFolder {
    /**
     * 
     * @type {string}
     * @memberof CreateExternalFolder
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateExternalFolder
     */
    parentId?: string | null;
}

export function CreateExternalFolderFromJSON(json: any): CreateExternalFolder {
    return CreateExternalFolderFromJSONTyped(json, false);
}

export function CreateExternalFolderFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateExternalFolder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
    };
}

export function CreateExternalFolderToJSON(value?: CreateExternalFolder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'parentId': value.parentId,
    };
}


